import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Transition from './transitions'
import { isEqualDate } from './dateUtils'
import EnhancedButton from './EnhancedButton'

class DayButton extends Component {
  static propTypes = {
    DateTimeFormat: PropTypes.func.isRequired,
    date: PropTypes.object,
    disabled: PropTypes.bool,
    locale: PropTypes.string.isRequired,
    onClick: PropTypes.func,
    onKeyboardFocus: PropTypes.func,
    selected: PropTypes.bool
  }

  componentWillMount() {
    window.addEventListener('resize', () =>
      this.setState({ height: window.innerHeight })
    )
    window.addEventListener('resize', () =>
      this.setState({ width: window.innerWidth })
    )
  }

  getStyles(props, context, state) {
    const { date, disabled, selected } = props
    const { hover } = state
    const { height } = this.state
    const { baseTheme, datePicker } = context.muiTheme

    let labelColor = baseTheme.palette.textColor
    let buttonStateOpacity = 0

    if (hover || selected) {
      labelColor = datePicker.selectTextColor
      buttonStateOpacity = selected ? 1 : 0.6
    } else if (isEqualDate(date, new Date())) {
      labelColor = datePicker.color
    }

    return {
      root: {
        boxSizing: 'border-box',
        fontWeight: '500',
        opacity: disabled && '0.4',
        padding: '4px 0px',
        position: 'relative',
        WebkitTapHighlightColor: 'rgba(0,0,0,0)', // Remove mobile color flashing (deprecated)
        width: height * 0.065
      },
      label: {
        color: labelColor,
        fontWeight: '500',
        position: 'absolute',
        top: height * 0.043,
        left:
          date && date.getDate().toString().length > 1
            ? height * 0.02
            : height * 0.0265
      },
      buttonState: {
        backgroundColor: datePicker.selectColor,
        borderRadius: '50%',
        height: height * 0.065,
        left: height * 0.0002,
        opacity: buttonStateOpacity,
        position: 'absolute',
        top: height * 0.025,
        transition: Transition.easeOut(),
        width: height * 0.065
      }
    }
  }

  static defaultProps = {
    selected: false,
    disabled: false
  }

  static contextTypes = {
    muiTheme: PropTypes.object.isRequired
  }

  state = {
    hover: false,
    height: window.innerHeight,
    width: window.innerWidth
  }

  handleMouseEnter = () => {
    if (!this.props.disabled) {
      this.setState({ hover: true })
    }
  }

  handleMouseLeave = () => {
    if (!this.props.disabled) {
      this.setState({ hover: false })
    }
  }

  handleClick = event => {
    if (!this.props.disabled && this.props.onClick) {
      this.props.onClick(event, this.props.date)
    }
  }

  handleKeyboardFocus = (event, keyboardFocused) => {
    if (!this.props.disabled && this.props.onKeyboardFocus) {
      this.props.onKeyboardFocus(event, keyboardFocused, this.props.date)
    }
  }

  render() {
    const {
      DateTimeFormat,
      date,
      disabled,
      locale,
      status,
      onClick, // eslint-disable-line no-unused-vars
      selected, // eslint-disable-line no-unused-vars
      ...other
    } = this.props

    const { prepareStyles } = this.context.muiTheme
    const styles = this.getStyles(this.props, this.context, this.state)
    return date ? (
      <EnhancedButton
        {...other}
        disabled={disabled}
        date={date}
        selected={selected}
        status={status}
        disableFocusRipple={true}
        disableTouchRipple={true}
        onKeyboardFocus={this.handleKeyboardFocus}
        onMouseEnter={this.handleMouseEnter}
        onMouseLeave={this.handleMouseLeave}
        onClick={this.handleClick}
        style={styles.root}
      >
        <div style={prepareStyles(styles.buttonState)} />
        <span style={prepareStyles(styles.label)}>
          {new DateTimeFormat(locale, {
            day: 'numeric'
          }).format(date)}
        </span>
      </EnhancedButton>
    ) : (
      <span style={prepareStyles(styles.root)} />
    )
  }
}

export default DayButton



// WEBPACK FOOTER //
// ./src/components/common/calendar/DayButton.js